import { useHippoText } from '../../hooks/useHippoText';
import { getCurrencyString } from '../../utils/currencyUtil';

const Currency = ({
    price,
    paymentFrequencyPostfix = '',
    currencyString,
    decimals = 2,
    displayZeroValue = false
}: {
    price: number;
    paymentFrequencyPostfix?: string;
    currencyString?: string;
    decimals?: number;
    displayZeroValue?: boolean;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    if (currencyString === undefined) {
        currencyString = ' ' + getHippoText('DSS-COMMON-PRICE-DELIMITER') ?? '';
    }
    const coverablePrice =
        price !== 0 || displayZeroValue
            ? getCurrencyString(price, currencyString, decimals) + paymentFrequencyPostfix
            : `- ${paymentFrequencyPostfix}`;
    return <>{coverablePrice}</>;
};

export default Currency;
